import { request } from "/src/utils/index.js";

export function GetCustomerListByDisease(params) {
  return request.get("/sdbs/customer/list/byDisease", { params });
}
